import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-section-title',
    templateUrl: './section-title.component.html',
    styleUrls: ['./section-title.component.scss'],
    standalone: false
})
export class SectionTitleComponent implements OnInit {
  @Input() title: string;
  @Input() desc: string;
  @Input() longTitle: boolean = false;

  constructor() {}

  ngOnInit(): void {}
}
